import { render, staticRenderFns } from "./SupervisorsListDialog.vue?vue&type=template&id=597ddf46&scoped=true&"
import script from "./SupervisorsListDialog.vue?vue&type=script&lang=js&"
export * from "./SupervisorsListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ddf46",
  null
  
)

export default component.exports